import { createSelector } from 'reselect';
import { shouldSuppressSsoLogin } from '../../config/ab/selector.js';
import { isBookingStateForPrivateWhiteLabel } from '../../utils/isPrivateWhiteLabel';

const shouldShowNewUsersSsoSelector = createSelector(
    (state) => {
        const isSsoSuppressed = shouldSuppressSsoLogin(state);
        const isPrivateCovidVaccineWhitelabel =
            isBookingStateForPrivateWhiteLabel(state);
        return !isSsoSuppressed && !isPrivateCovidVaccineWhitelabel;
    },
    /* createSelector is silly and breaks without this */
    (shouldShowNewUsersSso) => shouldShowNewUsersSso
);

export default shouldShowNewUsersSsoSelector;
